// extracted by mini-css-extract-plugin
export default {"addressOptions":"SuggestedAddress_addressOptions__xH3Rv"};